export const FETCH_FACILITIES = "FETCH_FACILITIES";

export const RESET_SEARCH = "RESET_SEARCH";

export const FETCH_FACILITY = "FETCH_FACILITY";

export const FETCH_GENERATOR = "FETCH_GENERATOR";

export const FETCH_TRANS1 = "FETCH_TRANS1";

export const FETCH_TRANS2 = "FETCH_TRANS2";

export const FETCH_TSDF = "FETCH_TSDF";

export const FETCH_ALTTSDF = "FETCH_ALTTSDF";

export const FETCH_NAICS = "FETCH_NAICS";

export const FETCH_CAMANIFESTCOUNTS = "FETCH_CAMANIFESTCOUNTS";

export const FETCH_OOSMANIFESTCOUNTS = "FETCH_OOSMANIFESTCOUNTS";

export const FETCH_CAWASTECODEMATRIX = "FETCH_CAWASTECODEMATRIX";

export const FETCH_RCRAWASTECODEMATRIX = "FETCH_RCRAWASTECODEMATRIX";

export const FETCH_WASTECODEMATRIX = "FETCH_WASTECODEMATRIX";

export const FETCH_MANIFESTS = "FETCH_MANIFESTS";

export const FETCH_MANIFEST = "FETCH_MANIFEST";

export const UPDATE_SELECTION = "UPDATE_SELECTION";

export const UPDATE_LOGINMODAL = "UPDATE_LOGINMODAL";

export const UPDATE_REPORTSMODAL = "UPDATE_REPORTSMODAL";

export const FETCH_TRANSPORTER = "FETCH_TRANSPORTER";

export const FETCH_COUNTIES = "FETCH_COUNTIES";

export const FETCH_CUPAS = "FETCH_CUPAS";

export const FETCH_CITIES = "FETCH_CITIES";

export const FETCH_SHIPYEARS = "FETCH_SHIPYEARS";

export const FETCH_WASTECODES = "FETCH_WASTECODES";

export const FETCH_YEARLYTONNAGEWASTECODE = "FETCH_YEARLYTONNAGEWASTECODE";

export const FETCH_YEARLYTONNAGEEPAID = "FETCH_YEARLYTONNAGEEPAID";

export const FETCH_YEARLYTONNAGEDISPOSAL = "FETCH_YEARLYTONNAGEDISPOSAL";

export const FETCH_YEARLYTONNAGEENTITY = "FETCH_YEARLYTONNAGEENTITY";

export const FETCH_PREVIOUSPAGEHISTORY = "FETCH_PREVIOUSPAGEHISTORY";

export const UPDATE_AUTH_USER = "UPDATE_AUTH_USER";

export const UPDATE_ACCESS_TOKEN = "UPDATE_ACCESS_TOKEN";

export const CANCEL_FACILITIES = "CANCEL_FACILITIES";

export const FETCH_LANDING_PAGE_COUNT = "FETCH_LANDING_PAGE_COUNT";
